import { EmailHealthHistory } from '@/components/popups/emal-health-history'
import EmailHealthReport from '@/pages/email-health/email-health-report'
import { EmailHealthProvider } from '@/pages/email-health/email-health-report/email-health-provider'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_private/domain-health/$domain-name/$esp-type',
)({
  component: DnsScoreDetails,
})

function DnsScoreDetails() {
  const { 'domain-name': domain, 'esp-type': espType } = Route.useParams()

  return (
    <div className="w-full">
      <EmailHealthProvider domain={domain} espType={espType}>
        <EmailHealthReport />
        <EmailHealthHistory domain={domain} />
      </EmailHealthProvider>
    </div>
  )
}
